



































































































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import UpdateDepositFixedTermMaturitySettingsRequest from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/UpdateDepositFixedTermMaturitySettingsRequest';
import FieldLabel from '@/components/Shared/FieldLabel.vue';
import ListUtils from '@/lib/listUtils';
import FixedTermMaturityType from "@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityType";
import FixedTermMaturityActionType from '@/models/Products/ProductSettings/DefaultSettings/FixedTermMaturity/FixedTermMaturityActionType';
import Amount from "@/models/Shared/Amount";
import PeriodType from '@/models/Shared/PeriodType';
import { ProductListModule } from '@/store/Products/ProductListModule';
import ProductSubType from "@/models/Products/ProductSubType";
import ProductIssueType from '@/models/Products/ProductIssues/ProductIssueType';

@Component({ name: 'AccountDepositFixedTermMaturitySettingsEditDialog', components: { FieldLabel } })
export default class extends SaascadaVueDialog {

    maturityWindowStartDateAsString: string = '';
    maturityDateAsString: string = '';

    maturityAction1ProductIssueSelectionType: string = '';

    request: UpdateDepositFixedTermMaturitySettingsRequest = new UpdateDepositFixedTermMaturitySettingsRequest(DepositAccountSettingsModule.settings.depositFixedTermMaturitySettings, new Date());
    FixedTermMaturityType = FixedTermMaturityType;
    FixedTermMaturityActionType = FixedTermMaturityActionType;
    PeriodType = PeriodType;
    ProductIssueType = ProductIssueType;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            // Get products specifically for the dialog to get ALL products and ignore pagination
            await ProductListModule.getProductsForDialog();
            this.request = new UpdateDepositFixedTermMaturitySettingsRequest(DepositAccountSettingsModule.settings.depositFixedTermMaturitySettings, new Date());
        }
    }

    @Watch('request.maturityType')
    async onMaturityTypeChanged() {
        // Depending on the type we need to reset values for relevant maturity actions
        if (this.request.maturityType === FixedTermMaturityType.Custom) {
            this.request.maturityAction1Type = FixedTermMaturityActionType.Reinvest;
            this.request.maturityAction1ProductId = undefined;
            this.request.maturityAction1ProductIssueId = undefined;
            this.request.maturityAction1Amount = new Amount();
            this.request.maturityAction2Type = FixedTermMaturityActionType.Withdrawal;
        }
        else {
            if (this.request.maturityType === FixedTermMaturityType.ReinvestFullBalance) {
                this.request.maturityAction1Type = FixedTermMaturityActionType.Reinvest;
            }
            if (this.request.maturityType === FixedTermMaturityType.FullWithdrawal) {
                this.request.maturityAction1Type = FixedTermMaturityActionType.Withdrawal;
            }
            this.request.maturityAction1ProductId = undefined;
            this.request.maturityAction1ProductIssueId = undefined;
            this.request.maturityAction1Amount = new Amount();
            this.request.maturityAction2Type = undefined;
        }
    }

    @Watch('maturityAction1ProductIssueSelectionType')
    async onMaturityAction1ProductIssueSelectionChanged() {
        await DepositAccountSettingsModule.getFixedTermMaturityAction1ProductIssues(this.request.maturityAction1ProductId);
    }

    get settings() {
        return DepositAccountSettingsModule.settings.depositFixedTermMaturitySettings;
    }

    get defaultWalletCurrency() {
        return DepositAccountSettingsModule.productIssue.generalSettings.defaultWalletCurrency;
    }

    get periodTypeOptions() {
        return ListUtils.periodTypeOptions();
    }

    get depositMaturityActionOptions() {
        return ListUtils.fixedTermMaturityTypesForAccountLevel();
    }

    get loading() {
        return ProductListModule.loading;
    }

    get maturityProductOptions() {
        // Only show products of specific sub types
        return ProductListModule.productsForDialog.filter(product => product.generalSettings.subType === ProductSubType.DepositFixedTerm || product.generalSettings.subType === ProductSubType.DepositSavingsAccount);
    }

    get maturityAction1ProductIssueOptions() {
        return DepositAccountSettingsModule.fixedTermMaturityAction1ProductIssues;
    }

    get maturityAction2ProductIssueOptions() {
        return DepositAccountSettingsModule.fixedTermMaturityAction2ProductIssues;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            //This needs setting to undefined currently as it is getting stored in the JSON.
            //Plan was to send this and backend ignores it until we get concurrency checking in
            this.request.updatedAt = undefined;

            await DepositAccountSettingsModule.editDepositFixedTermMaturitySettings(this.request);
        }
    }

}
